import {
  HANDIN_PROVIDER,
  LTI1P3_PROVIDER,
  QUIZZES_PROVIDER,
  TURNITIN_PROVIDER,
} from '@core/assignments/constants';

type Input = {
  accessingAsStaff: boolean;
  hasSubmission: boolean;
  isEducator: boolean;
  provider: string;
};

export const getSubmissionCapabilities = ({
  accessingAsStaff,
  hasSubmission,
  isEducator,
  provider,
}: Input) => ({
  canDelete:
    isEducator &&
    !accessingAsStaff &&
    provider === HANDIN_PROVIDER &&
    hasSubmission,
  canOpen:
    !accessingAsStaff &&
    [
      HANDIN_PROVIDER,
      TURNITIN_PROVIDER,
      LTI1P3_PROVIDER,
      QUIZZES_PROVIDER,
    ].includes(provider) &&
    hasSubmission,
});
